import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardTitle,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import classnames from 'classnames';
import './mensagens.style.css';
import Input from 'reactstrap/lib/Input';
import Col from 'reactstrap/lib/Col';
import Label from 'reactstrap/lib/Label';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const MensagensPage = props => {
  const intl = useIntl();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }
  return(
  <Modal
    className='modal-mensagem'
    size='lg'
    isOpen={props.modalMensagens}
    toggle={props.fechar}
  >
    <ModalHeader toggle={props.fechar}>{props.labelHeader}</ModalHeader>
    <ModalBody>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === '1' })}
            onClick={() => {
              props.toggle('1');
            }}
          >
            <IntlMessage id = "dashboards.examDetail.message.conversations"/>
          </NavLink>
        </NavItem>
        {false &&
          ((props.laudoModalMensagens && !props.exameEntregue) ||
            !props.laudoModalMensagens) && (
            <NavItem>
              <NavLink
                className={classnames({ active: props.activeTab === '2' })}
                onClick={() => {
                  props.toggle('2');
                }}
              >
                <IntlMessage id = "dashboards.examDetail.adding"/>
              </NavLink>
            </NavItem>
          )}
      </Nav>
      <br />
      <TabContent activeTab={props.activeTab}>
        <TabPane tabId='1'>
          <div
            id='idmodal'
            style={{
              height: `${props.altura}px`,
              width: '100%',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}
          >
            {props.sessoes.map(sessao => {
              return (
                <Card
                  key={sessao.id}
                  className={`sessao-mensagem  ${
                    sessao.lido === 'N' ? 'nao-lido' : ''
                  }`}
                >
                  <CardBody>
                    <CardTitle onClick={() => props.abrirConversa(sessao.id)}>
                      {`${sessao.laudo}${
                        sessao.nrExame ? ` - ${sessao.nrExame}` : ''
                      }`}
                      <br />
                      {sessao.paciente}
                    </CardTitle>
                    <div
                      className='sessao-body'
                      onClick={() => props.abrirConversa(sessao.id)}
                    >
                      <Row>
                        <Col>
                          <Row>
                            <a>
                              <strong><IntlMessage id = "dashboards.examDetail.message.subject"/></strong>
                              {` ${sessao.assunto}`}
                            </a>
                          </Row>
                          <Row>
                            <a>
                              <strong><IntlMessage id = "dashboards.examDetail.date"/></strong>
                              {` ${sessao.data}`}
                            </a>
                          </Row>
                        </Col>
                        <Col>
                          <div className='icon-sessao'>
                            {sessao.lido === 'N' && (
                              <i className='fas fa-envelope'></i>
                            )}
                            {sessao.lido === 'S' && (
                              <i className='fas fa-envelope-open'></i>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div
                      className='msg-collapse-header'
                      onClick={() => props.abrirConversa(sessao.id)}
                    >
                      <i
                        className={
                          'fas ' +
                          (sessao.aberta ? 'fa-chevron-up' : 'fa-chevron-down')
                        }
                      ></i>
                    </div>
                    {sessao.aberta && (
                      <div className='collapse-body' style={props.cssCollapse}>
                        <div
                          id='conversa'
                          className='collapse-conversas'
                          style={{
                            maxHeight: `450px`,
                            width: '100%',
                            overflowY: 'scroll',
                            overflowX: 'hidden'
                          }}
                        >
                          {props.mensagens.map((mensagem, index) => {
                            return (
                              <Row key={index}>
                                <div
                                  className={props.getClasseConversa(mensagem)}
                                >
                                  <div className='remetente-nome'>
                                    {mensagem.remetenteNome}&nbsp;
                                    <i className='fas fa-arrow-right'></i>
                                    &nbsp;{mensagem.destinatarioNome}
                                  </div>
                                  <div className={`item-conversa`}>
                                    {mensagem.texto}
                                    {mensagem.destinatarioId ===
                                      props.usuairoId && (
                                      <div
                                        className={'check ' + mensagem.lido}
                                        onClick={() =>
                                          props.checkMensagem(
                                            mensagem.id,
                                            sessao.id
                                          )
                                        }
                                      >
                                        <i className='fas fa-check-double'></i>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Row>
                            );
                          })}
                        </div>
                        {((props.laudoModalMensagens && !props.exameEntregue) ||
                          !props.laudoModalMensagens) && (
                          <div className='resposta'>
                            <SelectComponent
                              className='select-destino'
                              placeholder={translate("dashboards.examDetail.message.messageRecipient")}
                              options={props.usuarios}
                              onChange={e => {
                                props.atualizarDestinoMsg(e.value);
                              }}
                            />
                            <Input
                              type='textarea'
                              value={props.texto}
                              maxLength={500}
                              onChange={e =>
                                props.gravarTexto(e.currentTarget.value)
                              }
                            ></Input>
                            <Button
                              className='send-button'
                              color='primary'
                              onClick={() => props.enviarMensagem(sessao.id)}
                              disabled={
                                props.texto === '' ||
                                !props.destinatario ||
                                (props.laudoModalMensagens &&
                                  props.exameEntregue)
                              }
                            >
                              <IntlMessage id = "dashboards.examDetail.message.submit"/>
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              );
            })}
            {props.sessoes.length === 0 && (
              <div style={{ position: 'relative', textAlign: 'center' }}>
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 1000,
                    color: '#a9a4a4'
                  }}
                >
                  <IntlMessage id = "dashboards.examDetail.message.noConversationFound"/>
                </span>
              </div>
            )}
          </div>
        </TabPane>
        <TabPane tabId='2'>
          <Col className='add-sessao'>
            <Row>
              <Label style={{ width: '100%' }}>Laudo:</Label>
              <Input
                style={{ width: '150px' }}
                type='number'
                value={props.laudoSessao ? props.laudoSessao : ''}
                maxLength={100}
                disabled={props.laudoModalMensagens}
                onChange={e => props.gravarLaudoSessao(e.currentTarget.value)}
              ></Input>
            </Row>
            <Row>
              <Label><IntlMessage id = "dashboards.examDetail.message.conversationTopic"/></Label>
              <Input
                type='textarea'
                maxLength={100}
                value={props.assuntoSessao ? props.assuntoSessao : ''}
                onChange={e => props.gravarAssuntoSessao(e.currentTarget.value)}
              ></Input>
            </Row>
            <br />
            <Row className='primeira-msg'>
              <Label><IntlMessage id = "dashboards.examDetail.message.firstMessage"/></Label>
              <Input
                type='textarea'
                value={props.texto}
                maxLength={500}
                onChange={e => props.gravarTexto(e.currentTarget.value)}
              ></Input>
              <SelectComponent
                className='select-destino'
                placeholder={translate("dashboards.examDetail.message.messageRecipient")}
                options={props.usuarios}
                onChange={e => {
                  props.atualizarDestinoMsg(e.value);
                }}
              />
            </Row>
          </Col>
        </TabPane>
      </TabContent>
      {props.laudoModalMensagens && props.exameEntregue && (
        <div style={{ position: 'relative', textAlign: 'center' }}>
          <span style={{ color: '#094c09', fontWeight: 'bold' }}>
            <IntlMessage id = "dashboards.examDetail.message.blockedMessages"/>
          </span>
        </div>
      )}
    </ModalBody>
    <ModalFooter>
      <Button color='secondary' onClick={props.fechar}>
        <IntlMessage id = "dashboards.examDetail.close"/>
      </Button>
      {props.activeTab === '2' && (
        <Button
          color='primary'
          onClick={props.salvarNovaSessao}
          disabled={
            props.texto === '' ||
            !props.destinatario ||
            !props.assuntoSessao ||
            !props.laudoSessao
          }
        >
          <IntlMessage id = "dashboards.examDetail.message.submit"/>
        </Button>
      )}
    </ModalFooter>
  </Modal>
);
}

export default MensagensPage;



// WEBPACK FOOTER //
// ./src/app/common/mensagens/mensagens.page.js